<template lang="pug">
  div.home
    h1 Embedded
    p This screen assumes your system has all information from another page.
    p(v-show="loading") Loading rates...
    p(v-show="!loading && !ready") Error loading rates!
    swbc-sales-frame.frame(v-show="!loading && ready"
                           mode="selection"
                           :quote="quoteRequest"
                           @error="loadDone()"
                           @quote="loadDone")
</template>

<script>
  import { mapGetters } from 'vuex'
  import SwbcSalesFrame from '@/components/SwbcSalesFrame'
  export default {
    name: 'Embedded',
    components: {
      SwbcSalesFrame
    },
    data () {
      return {
        loading: true,
        ready: false
      }
    },
    methods: {
      loadDone (rates) {
        this.loading = false
        this.ready = !!rates
      }
    },
    computed: {
      ...mapGetters(['quoteRequest'])
    }
  }
</script>

<style lang="sass">
  .frame
    border: none
    height: 700px
    width: 800px
</style>
